import { Language, useLanguage } from '@/context/language-context'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export function LanguageSwitch() {
  const { language, setLanguage } = useLanguage()
  return (
    <Select
      value={language}
      onValueChange={(val) => setLanguage(val as Language)}
    >
      <SelectTrigger className='w-35'>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value='en'>English</SelectItem>
        <SelectItem value='tr'>Türkçe</SelectItem>
      </SelectContent>
    </Select>
  )
}
